import { Inertia } from '@inertiajs/inertia'
import React, { useRef } from 'react'
import { hasPermission } from '../../utils/Permissions';
import { roleLabel } from '../../utils/staffListHelpers';
import { birthdateFromIds } from '../../utils/mexicanIdBirthdate';
import Layout from '../../Shared/Layout/LayoutAdmin';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import AlertDismissible from '../../Shared/Components/AlertDismissible';
import PaginationList from '../../Shared/Components/PaginationList';
import { Link, usePage } from '@inertiajs/inertia-react'
import Commissions from './Commissions';
import Breadcrumbs from '../../Shared/Components/Breadcrumbs';
import { filterAssignableCorporateRoles } from '../../utils/corporateRoles';
import UserAvatar from '../../Shared/Components/UserAvatar';

const List = ({ items, positions, roles, filters = {} }) => {
    const assignableRoles = filterAssignableCorporateRoles(roles)
    const { flash } = usePage().props
    const [position_id, setPositionId] = React.useState(filters.position || '')
    const [search_text, setSearchText] = React.useState(filters.search || '')
    const [active_status, setActiveStatus] = React.useState(filters.active ?? '')
    const [role, setRole] = React.useState(filters.role || '')

    const paginationFilters = {
        search: search_text || undefined,
        position: position_id || undefined,
        active: active_status !== '' ? active_status : undefined,
        role: role || undefined,
    }

    function search() {
        Inertia.get(route('advisers.list'), paginationFilters, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
        })
    }

    function exportExcel() {
        // Exporta todos los asesores (sin filtros de la pantalla); encabezados en español
        window.location.href = route('advisers.export')
    }

    const CommissionsRef = useRef();

    const handleCommissionClick = (item) => {
        if (item.position?.nombre === 'FIELD TRAINER') {
            window.location.href = route('commission-metrics.adviser', item.id);
        } else {
            CommissionsRef.current.openDialog(item)
        }
    };

    const rows = items.data || []

    return (
        <Row>
            <div className="mb-7 mt-7">
                <Breadcrumbs currentPath="/admin/corporate_structure/advisers" />
            </div>

            <Commissions ref={CommissionsRef} onChange={() => { }} />

            <Col className="mt-4 mb-2 px-1">
                <h2>Listado de Asesores</h2>
            </Col>
            {flash.success && (
                <AlertDismissible message={flash.success} type="success" />
            )}
            {flash.error && (
                <AlertDismissible message={flash.error} type="danger" />
            )}
            <Row className="mb-4 px-1">
                <Col xs={12} className="px-1">
                    <div className="d-flex flex-wrap align-items-center">
                        <Form.Select className="form-control mx-2 mb-2" style={{ width: '170px' }} value={position_id} onChange={(e) => setPositionId(e.target.value)}>
                            <option value="">Todas las posiciones</option>
                            {positions.map((position) => (
                                <option key={position.id} value={position.id}>{position.nombre}</option>
                            ))}
                        </Form.Select>
                        <Form.Select className="form-control mx-2 mb-2" style={{ width: '150px' }} value={role} onChange={(e) => setRole(e.target.value)}>
                            <option value="">Todos los roles</option>
                            {assignableRoles.map((r) => (
                                <option key={r.id} value={r.name}>{r.label || r.name}</option>
                            ))}
                        </Form.Select>
                        <Form.Control value={search_text} placeholder="Nombre" type="text" onChange={(e) => setSearchText(e.target.value)} className="mx-2 mb-2" style={{ width: '160px' }} />
                        <Form.Select className="form-control mx-2 mb-2" style={{ width: '120px' }} value={active_status} onChange={(e) => setActiveStatus(e.target.value)}>
                            <option value="">Todos</option>
                            <option value="1">Activo</option>
                            <option value="0">Inactivo</option>
                        </Form.Select>
                        <Button onClick={search} variant="primary" className="btn-sm mx-2 mb-2" type="button">Filtrar</Button>
                    </div>
                    <div className="d-flex flex-wrap justify-content-end align-items-center">
                        <Button href="/templates/advisers_template.xlsx" variant="primary" className="me-3 btn btn-secondary btn-sm mb-2" type="button">Descargar Template Excel</Button>
                        {hasPermission('corporate_structure.advisers.import') && (
                            <Link href={route('advisers.excel.import')} className="me-3 btn btn-secondary btn-sm mb-2">Importar Excel</Link>
                        )}
                        {hasPermission('corporate_structure.advisers.export') && (
                            <Button onClick={exportExcel} variant="success" className="me-3 btn-sm mb-2" type="button">Exportar Excel</Button>
                        )}
                        {hasPermission('corporate_structure.advisers.create') && (
                            <Link href={route('advisers.add')} className="btn btn-primary btn-sm mb-2">Agregar Asesor</Link>
                        )}
                    </div>
                </Col>
            </Row>
            <div className="card card-flush h-md-100">
                <div className="card-body pt-6 px-2">
                    <div className="table-responsive mb-4">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                    <th className="p-0 pb-3 min-w-50px text-start">FOTO</th>
                                    <th className="p-0 pb-3 min-w-50px text-start">ID</th>
                                    <th className="p-0 pb-3 min-w-150px text-start ps-2">NOMBRE</th>
                                    <th className="p-0 pb-3 min-w-100px text-start ps-2">ROL</th>
                                    <th className="p-0 pb-3 min-w-150px text-start ps-2">FECHA DE REGISTRO</th>
                                    <th className="p-0 pb-3 min-w-80px text-start ps-2">OFICINA</th>
                                    <th className="p-0 pb-3 min-w-100px text-start ps-2">PUESTO</th>
                                    <th className="p-0 pb-3 min-w-100px text-start ps-2">ACTIVO</th>
                                    <th className="p-0 pb-3 min-w-120px text-start ps-2">CURP</th>
                                    <th className="p-0 pb-3 min-w-110px text-start ps-2">CUMPLEAÑOS</th>
                                    <th className="p-0 pb-3 min-w-100px text-start ps-2">STATUS DE DOCUMENTOS</th>
                                    <th width="200"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.length === 0 && (
                                    <tr>
                                        <td className="px-6 py-3 text-center" colSpan="12">No hay datos.</td>
                                    </tr>
                                )}
                                {rows.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <UserAvatar src={item.user?.photo_url} size={40} alt={item.user?.name || ''} />
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.id}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.user.name} {item.lastname_ap} {item.lastname_am}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{roleLabel(item)}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.created_at}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.office?.nombre}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.position?.nombre}</p>
                                        </td>
                                        <td>
                                            {item.active == 1 ? (
                                                <span className="badge py-2 px-3 fs-7 badge-light-success">Activo</span>
                                            ) : (
                                                <span className="badge py-2 px-3 fs-7 badge-light-danger">Inactivo</span>
                                            )}
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.curp || '—'}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">
                                                {birthdateFromIds(item.curp, item.rfc) || '—'}
                                            </p>
                                        </td>
                                        <td>
                                            {item.documents_complete === 1 ? (
                                                <span className="badge py-3 px-4 fs-7 badge-light-success">Completo</span>
                                            ) : (
                                                <span className="badge py-3 px-4 fs-7 badge-light-danger">Incompleto</span>
                                            )}
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-around">
                                                <div className="mx-2">
                                                    {hasPermission('corporate_structure.advisers.commissions') && (
                                                        <a href="#" onClick={(e) => { e.preventDefault(); handleCommissionClick(item) }}>Comisiones</a>
                                                    )}
                                                </div>
                                                <div className="mx-2">
                                                    <Link href={route('advisers.edit', item.id)}>Editar</Link>
                                                </div>
                                                <div className="mx-2">
                                                    <Link href={route('advisers.documents.edit', item.id)} className="ms-1">Docs</Link>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <PaginationList links={items.links} filters={paginationFilters} />
                </div>
            </div>
        </Row>
    );
}

List.layout = page => <Layout children={page} title="Asesores" />

export default List
